import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import {
  Environment,
  GetCommunicationAttachmentRequest
} from "@coxauto-ui/cxm/communications/interfaces";
import { GetCommunicationAttachmentRequestV2 } from "./interfaces/get-communication-attachment";

export async function getCommunicationAttachment(
  data: GetCommunicationAttachmentRequest,
  env: Environment
): Promise<ArrayBuffer | ResponseError> {
  const url = `${getBaseUrl(env)}CxM/attachment/id?ConsumerId=${
    data.consumerId
  }&CoxAutoMessageId=${data.coxAutoMessageId}&AttachmentId=${
    data.attachmentId
  }&ConsumerRecordSystem=${data.consumerRecordSystem}`;

  const header = await getHeader();

  const response = await fetchWrapper.getBinaryAsync(url, {
    ...header,
    "X-Signature": data.XSignature
  });
  if (response && response.data && !response.hasError) {
    return response.data;
  } else {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error,
      url
    };
    return error;
  }
}

export async function getCommunicationAttachmentV2(
  data: GetCommunicationAttachmentRequestV2,
  env: Environment
): Promise<ArrayBuffer | ResponseError> {
  const url = `${getBaseUrl(env)}CxM/attachment/id?CommunicationId=${
    data.communicationId
  }&AttachmentId=${data.attachmentId}&ConsumerId=${
    data.consumerId
  }&PresignedUrl=${encodeURIComponent(
    data.presignedUrl
  )}&Filename=${encodeURIComponent(
    data.filename
  )}&ContentType=${encodeURIComponent(data.contentType)}`;

  const header = await getHeader(2);

  const response = await fetchWrapper.getBinaryAsync(url, {
    ...header,
    "X-Signature": data.XSignature
  });

  if (response && response.data) {
    return response.data;
  } else {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error,
      url
    };
    return error;
  }
}
